import { useSearchParams } from 'react-router-dom';

export const FILTER_QUESTION_PREFIX = 'question_';

// Get the question option ids from the keys starting with 'question_' in the filter object
export const getQuestionOptionIds = () => {
  const [searchParams] = useSearchParams();
  const filter = JSON.parse(searchParams.get('filter') || '{}');

  return Object.keys(filter)
    .filter((key) => key.startsWith(FILTER_QUESTION_PREFIX))
    .map((key) => filter[key])
    .flat();
};

// Remove the keys starting with 'question_' from the filter object
export const removeQuestionFilter = (filter: any) => {
  const newFilter = { ...filter };

  Object.keys(filter).forEach((key) => {
    if (key.startsWith(FILTER_QUESTION_PREFIX)) {
      delete newFilter[key];
    }
  });

  return newFilter;
};

export const getFiltersValues = (searchQueryKey: string = 'filter') => {
  const [searchParams] = useSearchParams();
  const filter = JSON.parse(searchParams.get(searchQueryKey) || '{}');
  const questionOptionIds = getQuestionOptionIds();
  const cleanedFilter = removeQuestionFilter(filter);

  return {
    ...cleanedFilter,
    question_option_ids: questionOptionIds,
  };
};

export const sortDirection = (sort: string | null) => (sort?.startsWith('-') ? 'desc' : 'asc');

export const toggleSortParamDirection = (direction: string, sortAttr: string) =>
  direction === 'desc' ? sortAttr : `-${sortAttr}`;

export const isSortActive = (sort: string | null, paramName: string | null) => {
  if (!sort || !paramName) {
    return false;
  }

  return sort.includes(paramName);
};
